export function onScroll(element: Element, callback: EventListenerOrEventListenerObject) {
	element.addEventListener("scroll", callback)
}

export function removeScrollCallback(element: Element, callbackListToRemove: EventListenerOrEventListenerObject) {
	element.removeEventListener("scroll", callbackListToRemove);
}
